import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShoppingBag4"><Path fillRule="evenodd" clipRule="evenodd" d="M17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7H3V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V7H17ZM9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag4;
